// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"27bc627a","242":"e9482170","371":"4911ad94","402":"0f433cf8","613":"f3bb214d","616":"59758f16","822":"208ee701","859":"c886fabc"}[chunkId] + ".js";
};